import React from "react";
import ReactExport from "react-export-excel";
const ExcelFile = ReactExport.ExcelFile;
const ExcelSheet = ReactExport.ExcelFile.ExcelSheet;
const ExcelColumn = ReactExport.ExcelFile.ExcelColumn;

class Download extends React.Component {
    render() {
        let info=this.props.info||{};
        let datos =this.props.datos || [];
        let info_data=[];
        info_data.push({"nombre":"","valor":info.nombre});
        info_data.push({"nombre":"","valor":""});
        if(datos.length>0){
            info_data.push({"nombre":"Periodo","valor":info.unidad +"("+info.unidad_sigla+")"});
            datos.forEach(element => {
                info_data.push({"nombre":element.periodo,"valor": element.valor});
            });
        }
        info_data.push({"nombre":"","valor":""});
        info_data.push({"nombre":"","valor":"Fuente :"+info.fuente +" - "+info.dependencia});
        info_data.push({"nombre":"","valor":"Descargado desde el SISTEMA NACIONAL DE INFORMACIÓN AMBIENTAL"});
        info_data.push({"nombre":"","valor":this.formatDate()});
        return (
            <ExcelFile filename={"datos-"+this.getFilename()} element={<button title="Exportar a Excel"
            className="tool-button">
                <i className="fas fa-file-excel ml-3 col-size-max-icon"></i>
          </button>}>
             <ExcelSheet data={info_data} name="datos">
                 <ExcelColumn value="nombre" />
                 <ExcelColumn value="valor" />
            </ExcelSheet>
            </ExcelFile>
        );
    }
    getFilename() {
        var date = new Date();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        return this.formatNumber(date.getDate()) + "-" + this.formatNumber((date.getMonth()+1)) + "-" + date.getFullYear();
    }
    formatDate() {
        var date = new Date();
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0'+minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return this.formatNumber(date.getDate()) + "/" + this.formatNumber((date.getMonth()+1)) + "/" + date.getFullYear() + "  " + strTime;
    }
    formatNumber(number){
        if(number<10){
            return "0"+number;
        }
        return number;
    }
}

export default Download;